import AiTextWriter from '../../../src/components/content-ai-tools/AiTextWriter';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const AiTextGenerator = () => {
  return <ToolsStyleWrapper component={AiTextWriter} />;
};

export default AiTextGenerator;
